export const examAdminQuestions = {
  pageTitle: "题库中心",
  pageSubtitle: "按题型使用可视化表单录入题目，系统自动生成题目编号和结构化数据。",
  createQuestion: "新建题目",
  createSuccess: "問題を作成しました",
  deleteSuccess: "問題を削除しました",
  searchPlaceholder: "問題番号または問題文で検索",
  stemSummary: "問題文要約",
  createTitlePrefix: "新規作成：",
  createFallbackTypeName: "問題",
  showArchived: "アーカイブを表示",
  hideArchived: "アーカイブを隠す",
  summaryArchivedVisible: "アーカイブ表示：{value}",
  statusUpdated: "問題の状態を更新しました",
  archivedSuccess: "問題をアーカイブしました",
  summaryTotal: "問題総数：{count}",
  summarySelected: "選択中の問題：{count}",
  overview: {
    total: "問題総数",
  },
  taskEditor: {
    createTitle: "問題を新規作成",
    editTitle: "問題を編集",
    saveFirstToDebug: "先に問題を保存してから、デバッグワークスペースをご利用ください。",
    viewModeDebugHint:
      "現在は閲覧モードです。右上の「編集」をクリックするとデバッグワークスペースを利用できます。",
    runExecStatus: "実行状態",
    runCaseStatus: "ケース結果",
    runExecPass: "実行成功",
    runExecFail: "実行失敗",
    candidateRunPass: "合格",
    candidateRunFail: "不合格",
    unsavedLeaveConfirm: "未保存の変更があります。このまま離れますか？",
    tabs: {
      config: "設定",
      examView: "受験者視点",
      fullInfo: "全情報",
      versionHistory: "バージョン履歴",
      debug: "デバッグ",
      versions: "バージョン",
    },
  },
  messages: {
    selectDraftsToPublish: "公開できるのは下書き問題のみです。選択をやり直してください。",
    selectArchivableToArchive: "アーカイブ可能な問題が選択されていません",
    selectDraftsToDelete: "削除できるのは下書き問題のみです。選択をやり直してください。",
    batchPublished: "{count} 問の問題を公開しました",
    batchArchived: "{count} 問の問題をアーカイブしました",
    batchDeleted: "{count} 件の下書き問題を削除しました",
  },
  batchSelection: {
    partialSelected:
      "先頭 {selected} 件を選択しました（現在の絞り込み対象は全 {total} 件で、超過分は未選択です）",
    allSelected: "{count} 件を選択しました",
  },
  confirmArchiveSingle: {
    title: "この問題をアーカイブしますか？",
    description: "アーカイブした問題は通常の一覧には表示されません。",
  },
  confirmBatch: {
    publishDraftsTitle: "選択した {count} 問の下書き問題を公開しますか？",
    archiveTitle: "選択した {count} 問をアーカイブしますか？",
    deleteDraftsTitle: "選択した {count} 件の下書き問題を削除しますか？",
    deleteDraftsDescription: "この操作は取り消せません。",
    archiveDescription: "アーカイブした問題は通常の一覧には表示されません。",
  },
  batch: {
    publishDrafts: "一括公開（下書きのみ）",
    archive: "一括アーカイブ",
    deleteDrafts: "一括削除（下書きのみ）",
    confirmDeleteDraftsDescription: "削除後は元に戻せません。",
    archiveAction: "アーカイブ",
    confirmPublishDraftsTitle: "選択中の下書き問題を一括公開しますか？",
    confirmArchiveTitle: "選択中の問題を一括アーカイブしますか？",
    confirmDeleteDraftsTitle: "選択中の下書き問題を一括削除しますか？",
    publishAction: "公開",
  },
  drawerTitleCreate: "新建题目",
  previewTitle: "题目预览（考生视角）",
  codeRulePrefix: "题目编号由系统在首次保存成功后自动生成，格式为",
  codeRulePattern: "Q-题型字母-年周-序号",
  codeRuleSuffix: "，生成后不可修改。",
  stats: {
    total: "总题数：{count}",
    published: "已发布：{count}",
    draft: "草稿：{count}",
    summaryUnavailable: "問題の凡例件数の読み込みに失敗したため、件数を表示できません",
  },
  table: {
    code: "题目编号",
    title: "标题",
  },
  confirmDelete: {
    title: "确认删除这个题目吗？",
    description: "仅未被试卷或作答引用的题目允许删除。",
  },
  preview: {
    unnamedTitle: "未命名题目",
    emptyStem: "暂无题干",
    judgmentTrue: "正确",
    judgmentFalse: "错误",
    shortAnswerPlaceholder: "考生将在此输入简答内容",
    codePlaceholder: "考生将在此编写代码",
    publicCases: "示例 / 公开用例",
    noPublicCases: "暂无公开用例",
    caseTitle: "用例 {index}",
    input: "输入：",
    output: "输出：",
    explanation: "说明：",
    practicalDescription: "该题为实操题，考生进入后可创建环境并按要求完成操作。",
    accessHint: "访问说明：{value}",
    noAccessHint: "暂无",
    attackDefenseAttachmentDescription: "该题为附件类夺旗题，请下载附件后本地分析并提交 flag。",
    attachmentAssets: "附件资源：{value}",
    noAssets: "暂无",
    flagPlaceholder: "考生将在此输入 flag，例如 flag{...}",
  },
  editor: {
    sections: {
      choiceAnswer: "選択肢と解答",
      referenceAnswerPoints: "模範解答と採点ポイント",
      judgeConfig: "判定設定",
      environmentConfig: "環境設定",
      attackDefenseConfig: "攻防設定",
      aiMeta: "AI メタ情報",
      structuredPreview: "構造化プレビュー",
    },
    labels: {
      taskTitle: "問題名",
      taskDescription: "問題説明",
      correctAnswerMultiple: "正解（複数選択可）",
      internalNote: "内部メモ（作成者/管理者のみ表示）",
      tags: "問題タグ",
      knowledgePoints: "知識ポイント",
      aiSource: "AI ソース",
      aiGenerated: "AI 生成フラグ",
      effectivePorts: "有効ポート",
      image: "イメージ識別子",
      publicCase: "サンプル/公開ケース",
      hiddenCase: "非公開ケース",
    },
    objects: {
      choiceOption: "選択肢",
      keyword: "キーワード",
      scoringPoint: "採点ポイント",
      publicCase: "公開ケース",
      hiddenCase: "非公開ケース",
      experienceEnvironment: "体験環境",
      temporaryEnvironment: "一時環境",
    },
    actions: {
      aiFill: "AI 入力",
      manualAdd: "手動追加",
      selectFromImageList: "イメージ一覧から選択",
      select: "選択",
      uploadAssetToLibrary: "添付ファイルをアセット庫へアップロード",
    },
    messages: {
      required: "必須です",
      selectQuestionType: "問題タイプを選択してください",
      inputTitle: "問題タイトルを入力してください",
      inputStem: "問題文を入力してください",
      inputOptionText: "選択肢の文言を入力してください",
      selectCorrectAnswer: "正解を選択してください",
      selectAtLeastOneLanguage: "少なくとも 1 つの言語を選択してください",
      inputCaseInput: "入力例を入力してください",
      inputCaseOutput: "期待出力を入力してください",
      selectImage: "イメージ識別子を選択してください",
      selectContainerPort: "コンテナポートを選択してください",
      inputStandardFlag: "標準 Flag を入力してください",
      requireInitScriptForDynamicFlag: "動的 Flag モードでは初期化スクリプトが必須です",
      selectAtLeastOneAttachment: "少なくとも 1 つの添付ファイルを選択してください",
      uploadAssetSuccess: "添付ファイルをアップロードしました：{filename}",
      uploadAssetFailed: "添付ファイルのアップロードに失敗しました",
      noUsableAnalysis:
        "AI から利用可能な解説が返りませんでした。しばらくしてから再試行するか、手動で入力してください。",
      analysisFilled: "AI が解説を入力しました",
      analysisFailed: "AI 解説の生成に失敗しました",
      noUsableTags:
        "AI から利用可能なタグが返りませんでした。しばらくしてから再試行するか、手動で入力してください。",
      tagsFilled: "AI がタグを入力しました",
      tagsFailed: "AI タグの生成に失敗しました",
      noUsableKnowledgePoints:
        "AI から利用可能な知識ポイントが返りませんでした。しばらくしてから再試行するか、手動で入力してください。",
      knowledgePointsFilled: "AI が知識ポイントを入力しました",
      knowledgePointsFailed: "AI 知識ポイントの生成に失敗しました",
    },
    placeholders: {
      title: "問題タイトルを入力",
      stem: "問題文、背景説明、または操作要件を入力",
      referenceAnswer: "模範解答または採点参考を入力",
      keywordExample: "例：SQL インジェクション、パラメータ化クエリ",
      pointExample: "例：リスクを指摘し、修正案を提示する",
      languageExample: "例：python, java, cpp",
      starterCode: "デフォルトのテンプレートコードを入力",
      codeCaseInputExample: "例：3 5（2 つの引数はスペース区切り。改行入力も可）",
      codeCaseOutputExample: "例：8",
      executionHintExample: "例：標準入出力を使用し、ネットワークアクセスは禁止",
      image: "イメージ識別子を選択してください",
      containerPort: "コンテナポートを選択してください",
      imageKeyword: "イメージ名またはイメージ識別子で絞り込み",
      attachment: "添付ファイルを選択してください",
      analysis: "問題解説、注意事項、または参考方針を入力",
      internalNote: "内部メモ。試験側には表示されません",
      tagsExample: "例：セキュリティ、データベース、コンテナ",
      knowledgePointsExample: "例：SQL インジェクション、ファイアウォールポリシー",
      aiSource: "例：AIタスク #123（百錬） / 手動修正",
    },
    hints: {
      imageListEmpty: "先にイメージ管理で利用可能なイメージを取得してください。",
      imageListManaged:
        "イメージ一覧はイメージ管理から取得され、管理済みのイメージ識別子のみ選択できます。",
      imageListManagedShort: "イメージ一覧はイメージ管理から取得されます（イメージ識別子で選択）。",
      imagesLoading: "イメージを読み込み中",
      noImagesAvailable: "利用可能なイメージがありません。先にイメージ管理で取得してください。",
      imagePicker:
        "ダイアログでイメージ名またはイメージ識別子を絞り込み、選択した「イメージ識別子」を項目へ反映できます。",
      noDeclaredPortWithGovernance:
        "現在のイメージにはポート宣言がありません。別のイメージを選ぶか、先にイメージガバナンスで EXPOSE を補ってください。",
      noDeclaredPort:
        "現在のイメージにはポート宣言がありません。別のイメージを選ぶか、EXPOSE を補ってください。",
      practicalInitScript:
        "スクリプト注記：プラットフォームはコンテナ内で `sh -s` によりスクリプトを実行します。よく使うディレクトリは `/workspace` を推奨し、スクリプトは再実行可能（冪等）にしてください。",
      callbackMode:
        "コールバックモードではプラットフォーム側の検査スクリプトは不要です。イメージ内のプログラムが完了状態をプラットフォームへ報告する必要があります。",
      practicalCheckScript:
        "検査スクリプト規約：終了コード `0` は合格、非 `0` は失敗です。失敗時は stderr に明確なエラー情報を出力することを推奨します。",
      hiddenCasesForJudge: "非公開ケースは最終判定に使用され、受験者には表示されません。",
      dynamicFlagContainerOnly:
        "動的 Flag は環境インスタンスの作成と注入に依存し、媒体はコンテナモードに固定されます。",
      attackInitScript:
        "規約：起動フローはイメージ内に固定してください。初期化スクリプトは問題インスタンス単位の準備に使い、動的 Flag モードでは必須です。",
      assetSource: "添付ファイルはアセットモジュール由来で、複数選択できます。",
      attachmentMode:
        "添付ファイルモードは静的解析系問題に使用します。アップロード後はドロップダウンから直接選択できます。",
      dynamicFlagValidation:
        "動的 Flag は環境インスタンス作成時に受験者単位で生成され、コンテナ環境変数へ注入されます。プラットフォームは検証用ハッシュのみ保存します。",
      aiSourceExtra:
        "この内容がどの AI タスクまたは手動修正に由来するかを記録します。例：AIタスク #123（百錬）または手動修正。",
      structuredPreview:
        "このページはフォーム入力を中心とし、システムが構造化 JSON を自動生成します。下のプレビューは最終保存内容の確認用です。",
      practicalEditor:
        "初期化スクリプトと検査スクリプトを編集しながら検証するために使います。環境作成後、初期化スクリプトは自動的に 1 回実行されます。",
    },
    enums: {
      environmentType: {
        virtualMachine: "仮想マシン",
      },
      checkMode: {
        exec: "コンテナ外 exec 検査",
        callback: "コンテナ内 callback 報告",
      },
    },
    switches: {
      aiGenerated: "AI 生成",
      manualCreated: "手動作成",
    },
    scripts: {
      practicalCheckExample:
        '#!/bin/sh\nset -eu\n\n# 重要ファイルが存在するか確認\ntest -f /workspace/app/answer.txt\n\n# ファイル内容が期待値と一致するか確認\nexpected="hello-exam"\nactual="$(cat /workspace/app/answer.txt)"\n[ "$actual" = "$expected" ]',
      attackInitExample:
        '#!/bin/sh\nset -eu\n\n# 起動スクリプトはイメージ内の ENTRYPOINT/CMD が担当します。ここでは問題インスタンスの初期化のみ行います。\n# 例：動的 flag をアプリが読み取る場所へ書き込みます（イメージ構造に合わせて調整してください）\nmkdir -p /workspace\necho "$EXAM_DYNAMIC_FLAG" > /workspace/flag.txt',
    },
    ai: {
      sourceFormat: "AIタスク #{taskId}（{mode}）",
      modes: {
        bailian: "百錬",
        placeholder: "ルール生成",
        placeholderFallback: "ルール補完",
        local: "ローカル生成",
      },
    },
  },
} as const;
